<app-page [id]="id" >
  <div class="flex flex-column md:flex-row gap-3 w-full justify-content-around p-3">
    <div class="flex flex-column gap-3 w-12">
  <div class="col-12">
    <app-card  title="Wsz" class="col-12 md:col-12 lg:col-12" >
      <google-map 
        height="500px" 
        width="100%" 
        [center]="center" 
        [zoom]="zoom" 
        [options]="options">
      </google-map> 
    </app-card>
      </div>
    </div>
  </div>

  <div footer class="text-center" >
    <div>
      <div class="p-2 flex flex-end w-full" style="justify-content: end;">
        <app-button (click)="onSendClick()"  [fullWidth]="false"  icon="send" label="Trasmetti" raised/>
      </div>
    </div>
  </div> 
</app-page>
